export default ($) => {
  $('select.custom').each(function() {
    let $this = $(this),
      numberOfOptions = $(this).children('option').length;
    let miniSelect = $this.hasClass('mini-select');
    let selectStyledClass = 'select-styled';

    if (miniSelect) {
      selectStyledClass = selectStyledClass + ' mini-styled btn arrow';
    }

    $this.wrap('<div class="select" tabindex="0"></div>');
    $this.closest('.select').addClass('custom');
    $this.addClass('select-hidden');

    $this.after('<div class="' + selectStyledClass + '"></div>');
    let $styledSelect = $this.next('div.select-styled');

    let selectedOption = $this.find('option:selected');
    let selectedText = selectedOption.length ? selectedOption.text() : $this.children('option').eq(0).text();
    let selectedValue = selectedOption.val();

    $styledSelect.text(selectedText);

    if (selectedValue) $styledSelect.addClass('hasValue');

    if (miniSelect) {
      $styledSelect.text($this.data('title'));
      $(this).val('').change();
    }

    let $list = $('<ul />', {
      'class': 'select-options js-' + $(this).attr('name')
    }).insertAfter($styledSelect);
    if (miniSelect) {
      $('<li />', {
        text: $this.data('title'),
        rel: '',
      }).appendTo($list);
    }
    for (let i = 0; i < numberOfOptions; i++) {
      let currentOption = $this.children('option').eq(i);
      $('<li />', {
        class: currentOption.prop('disabled') ? 'disabled' : '',
        text: currentOption.text(),
        rel: currentOption.val(),
      }).appendTo($list);
    }

    let $listItems = $list.children('li');
    $list.hide();

    $styledSelect.click(function(e) {
      e.stopPropagation();
      $('.select-styled.active').not(this).removeClass('active').next('ul.select-options').hide();
      $(this).toggleClass('active').next('ul.select-options').toggle();
    });

    $listItems.click(function(e) {
      e.stopPropagation();
      $styledSelect.text($(this).text()).removeClass('active');
      $list.hide();
      $this.val($(this).attr('rel')).change();

      $this.val() ? $styledSelect.addClass('hasValue') : $styledSelect.removeClass('hasValue');
    });

    $(document).click(function(event) {
      if (!$(event.target).closest($this).length) {
        $styledSelect.removeClass('active');
        $list.hide();
      }
    });
  });

  (() => {
    let lookingForForm = $('.js-lfForm');

    let activateInterest = (selectJQElement, button) => {
      selectJQElement.on('change', function () {
        let currentVal = $(this).find('option:selected').val();
        button.attr('href', currentVal);
        button.attr('disabled', false);
      });
    };

    lookingForForm.each(function () {
      let _form = $(this);
      let categorySelect = _form.find('.js-lfFormCategory');
      let linksSelect    = _form.find('.js-lfFormLinks');
      let button         = _form.find('.js-learnMoreBtn');

      categorySelect.on('change', function () {
        let currentLinks = $(this).find('option:selected').data('links');
        let styledSelect = linksSelect.next('.select-styled');
        let listBox      = linksSelect.siblings('.select-options');

        button.attr('disabled', true);

        linksSelect.empty();
        listBox.empty();
        styledSelect.removeClass('hasValue');

        Array.prototype.forEach.call(currentLinks, function (item, index) {
          let text = item['title'] ? item['title'] : item['name'];

          if (index === 0) {
            styledSelect.text(text);
            button.attr('href', item['url']);
          }

          $('<option />', {
            value: item['url'],
            text: text,
          }).appendTo(linksSelect);

          $('<li />', {
            text: text,
            rel: item['url'],
            class: text === 'Looking for...' ? 'disabled' : ''
          }).appendTo(listBox);
        });

        let $listItems = listBox.children('li');

        $listItems.click(function(e) {
          e.stopPropagation();
          styledSelect.text($(this).text()).removeClass('active');
          listBox.hide();
          linksSelect.val($(this).attr('rel')).change();

          linksSelect.val() ? styledSelect.addClass('hasValue') : styledSelect.removeClass('hasValue');
        });

        activateInterest(linksSelect, button);
      });

      activateInterest(linksSelect, button);
    });
  })();
}